<div class="flex-fill d-flex flex-row">
    <div class="flex-shrink-0 sidebar">
        <div class="toolbar m-3">
            <dx-button text="Close" type="default" accessKey="c" (onClick)="close()" [visible]="!hasChanges()"></dx-button>
            <dx-button text="Save" type="success" accessKey="s" (onClick)="save()" [visible]="hasChanges()"></dx-button>
            <dx-button text="Cancel" type="danger" (onClick)="cancel()" [visible]="hasChanges()"></dx-button>
        </div>
        <div class="toolbar m-3">
            <dx-button text="Save & Start" type="success" (onClick)="saveAndStart()" [visible]="canSaveAndStart"></dx-button>
        </div>
        <div class="m-3"></div>
        <div class="border-top m-3"></div>
        @if (rentalMarginInfos && canSeeMargins) {
            <div class="m-3">
                <dx-button
                    class="btn btn-sm btn-primary mt-2"
                    text="Refresh"
                    (click)="getRentalMarginInformation()"
                    [disabled]="!canSeeMargins"
                ></dx-button>
                <div class="mt-1 font-bold">Rental Margin (since 5/1/2025): {{ rentalMarginInfos.rentalMargin | percent: '1.2-2' }}</div>
                <div class="mt-2 font-bold">Invoiced Total: {{ rentalMarginInfos.invoiceTotal | currency }}</div>
                <div class="font-bold">Total Time Expense: {{ rentalMarginInfos.totalTimeExpense | currency }}</div>
                <div class="font-bold">Total Tons Expense: {{ rentalMarginInfos.totalTonExpense | currency }}</div>
                <div class="mt-2 font-bold">Total Time: {{ rentalMarginInfos.totalTime | number: '1.2-2' }}</div>
                <div class="font-bold">Total Tons: {{ rentalMarginInfos.totalTons | number: '1.2-2' }}</div>
                <div class="font-bold">Total Jobs: {{ rentalMarginInfos.totalJobs }}</div>
                <div class="font-bold">Avg. Hr/Job: {{ rentalMarginInfos.averageTimePerJob | number: '1.2-2' }}</div>
            </div>
        }
    </div>
    <div class="flex-fill dx-card responsive-paddings">
        @if (rental) {
            <div class="flex-fill content-block" autofocus>
                @if (rental) {
                    <dx-form [formData]="rental" validationGroup="mainValidationGroup" appAutofocusForm [colCount]="3">
                        @if (canUpdateCustomer) {
                            <dxi-form-item
                                dataField="customerId"
                                [label]="{ text: 'Customer' }"
                                [editorType]="'dxSelectBox'"
                                [editorOptions]="{
                                    dataSource: customersDS,
                                    valueExpr: 'id',
                                    displayExpr: 'displayName',
                                    onValueChanged: customerChanged
                                }"
                            >
                                <dxi-form-validation-rule type="required" message="Required"> </dxi-form-validation-rule>
                                <dxi-form-validation-rule type="range" [min]="1" message="Required"> </dxi-form-validation-rule>
                            </dxi-form-item>
                        }
                        <dxi-form-item [colSpan]="2">
                            <div *dxTemplate>
                                @if (canUpdateCustomer) {
                                    <button class="btn btn-sm btn-primary mt-2" (click)="addCustomer()">Add Customer</button>
                                }
                                @if (!canUpdateCustomer) {
                                    <button class="btn btn-sm btn-success mt-2" (click)="addCustomer(rental.customer)">
                                        Edit Customer
                                    </button>
                                }
                                @if (canChangeSiteAddress) {
                                    <button class="btn btn-sm btn-primary ms-2 mt-2" (click)="addSite()" [disabled]="!canAddSite">
                                        Add Site Address
                                    </button>
                                }
                                @if (!canChangeSiteAddress) {
                                    <button
                                        class="btn btn-sm btn-success ms-2 mt-2"
                                        (click)="addSite(rental.serviceAddress)"
                                        [disabled]="!canAddSite"
                                    >
                                        Edit Site Address
                                    </button>
                                }
                            </div>
                        </dxi-form-item>
                    </dx-form>
                }
                <div class="row mt-2">
                    <dx-form [formData]="customer" [readOnly]="true" class="col-4" validationGroup="mainValidationGroup">
                        <dxi-form-item itemType="group" caption="Customer Information" [colCount]="2">
                            @if (customer?.typeId === 1) {
                                <dxi-form-item dataField="companyName" [colSpan]="2"></dxi-form-item>
                            }
                            <dxi-form-item dataField="firstName"></dxi-form-item>
                            <dxi-form-item dataField="lastName"></dxi-form-item>
                            <dxi-form-item
                                dataField="notes"
                                [label]="{ text: 'Customer Notes' }"
                                editorType="dxTextArea"
                                [colSpan]="2"
                                [editorOptions]="{ height: 100 }"
                            >
                            </dxi-form-item>
                        </dxi-form-item>
                        <dxi-form-item itemType="group" caption="Photos" [visible]="key !== 'new'">
                            <dxi-form-item>
                                <div *dxTemplate>
                                    <dx-file-uploader
                                        name="fileUpload"
                                        selectButtonText="Select Photo(s)"
                                        labelText="or drop a photo here"
                                        uploadMode="instantly"
                                        accept="image/*"
                                        [allowedFileExtensions]="imageExtensions"
                                        [showFileList]="false"
                                        [multiple]="true"
                                        [uploadUrl]="uploadUrl"
                                        [uploadHeaders]="uploadHeader"
                                        (onUploadStarted)="uploadStarted($event)"
                                        (onUploadError)="uploadError($event)"
                                        (onUploaded)="uploaded($event)"
                                    >
                                    </dx-file-uploader>
                                </div>
                            </dxi-form-item>
                            <dxi-form-item>
                                <ul class="file-list">
                                    @for (photo of photos; track photo) {
                                        <li>
                                            <a title="remove" class="me-2" (click)="removePhoto(photo)">
                                                <i class="fa fa-times" aria-hidden="true"></i>
                                            </a>
                                            <a title="edit" class="me-2" (click)="editPhoto(photo)">
                                                <i class="fa fa-pencil" aria-hidden="true"></i>
                                            </a>
                                            <a title="view" (click)="openPhoto(photo)">{{ photo.name }}</a>
                                        </li>
                                    }
                                </ul>
                            </dxi-form-item>
                        </dxi-form-item>
                    </dx-form>
                    <dx-form class="col-4" validationGroup="mainValidationGroup">
                        <dxi-form-item itemType="group" caption="Site Information" [colCount]="2">
                            <dxi-form-item [label]="{ text: 'Site' }" [colSpan]="2">
                                <div *dxTemplate>
                                    <dx-select-box
                                        [(value)]="rental.serviceAddressId"
                                        [items]="customer?.serviceAddresses"
                                        valueExpr="id"
                                        displayExpr="displayName"
                                        [searchEnabled]="true"
                                        [showClearButton]="true"
                                        [readOnly]="!canChangeSiteAddress"
                                    ></dx-select-box>
                                </div>
                                <dxi-form-validation-rule type="required" message="Required"> </dxi-form-validation-rule>
                                <dxi-form-validation-rule type="range" [min]="1" message="Required"> </dxi-form-validation-rule>
                            </dxi-form-item>
                            <dxi-form-item [label]="{ text: 'Name' }" [colSpan]="2">
                                <div *dxTemplate>
                                    <dx-text-box [value]="rental?.serviceAddress?.siteName" [readOnly]="true"></dx-text-box>
                                </div>
                            </dxi-form-item>
                            <dxi-form-item [label]="{ text: 'Address' }" [colSpan]="2">
                                <div *dxTemplate>
                                    <dx-text-box [value]="rental?.serviceAddress?.address1" [readOnly]="true"></dx-text-box>
                                </div>
                            </dxi-form-item>
                            <dxi-form-item [label]="{ text: 'City' }">
                                <div *dxTemplate>
                                    <dx-text-box [value]="rental?.serviceAddress?.city" [readOnly]="true"></dx-text-box>
                                </div>
                            </dxi-form-item>
                            <dxi-form-item [label]="{ text: 'State' }">
                                <div *dxTemplate>
                                    <dx-text-box [value]="rental?.serviceAddress?.state" [readOnly]="true"></dx-text-box>
                                </div>
                            </dxi-form-item>
                            <dxi-form-item [label]="{ text: 'Zip' }">
                                <div *dxTemplate>
                                    <dx-text-box [value]="rental?.serviceAddress?.zip" [readOnly]="true"></dx-text-box>
                                </div>
                            </dxi-form-item>
                            <dxi-form-item [label]="{ text: 'County' }">
                                <div *dxTemplate>
                                    <dx-text-box [value]="rental?.serviceAddress?.county" [readOnly]="true"></dx-text-box>
                                </div>
                            </dxi-form-item>
                            <dxi-form-item [label]="{ text: 'Latitude' }">
                                <div *dxTemplate>
                                    <dx-text-box [value]="rental?.serviceAddress?.latitude.toString()" [readOnly]="true"></dx-text-box>
                                </div>
                            </dxi-form-item>
                            <dxi-form-item [label]="{ text: 'Longitude' }">
                                <div *dxTemplate>
                                    <dx-text-box [value]="rental?.serviceAddress?.longitude.toString()" [readOnly]="true"></dx-text-box>
                                </div>
                            </dxi-form-item>
                            <dxi-form-item [label]="{ text: 'Range' }">
                                <div *dxTemplate>
                                    <dx-text-box [value]="rental?.serviceAddress?.range" [readOnly]="true"></dx-text-box>
                                </div>
                            </dxi-form-item>
                            <dxi-form-item [label]="{ text: 'Price/Ton' }">
                                <div *dxTemplate>
                                    <dx-text-box [value]="rental?.serviceAddress?.pricePerTon.toString()" [readOnly]="true"></dx-text-box>
                                </div>
                            </dxi-form-item>
                            <dxi-form-item [label]="{ text: 'Notes' }" [colSpan]="2">
                                <div *dxTemplate>
                                    <dx-text-area
                                        [value]="rental?.serviceAddress?.notes"
                                        [height]="'100px'"
                                        [readOnly]="true"
                                    ></dx-text-area>
                                </div>
                            </dxi-form-item>
                        </dxi-form-item>
                    </dx-form>
                    <dx-form [formData]="rental" class="col-4" [validationGroup]="'mainValidationGroup'">
                        <dxi-form-item itemType="group" caption="Rental Information" [colCount]="4">
                            <dxi-form-item dataField="startDate" editorType="dxDateBox">
                                <dxi-form-validation-rule type="required"> </dxi-form-validation-rule>
                            </dxi-form-item>
                            <dxi-form-item dataField="endDate" editorType="dxDateBox"></dxi-form-item>
                            <dxi-form-item dataField="pONumber" [label]="{ text: 'PO Number' }"></dxi-form-item>
                            <dxi-form-item itemType="empty"></dxi-form-item>
                            <dxi-form-item [label]="{ text: 'Dumpster' }">
                                <div *dxTemplate>
                                    <dx-select-box
                                        [(value)]="rental.dumpsterId"
                                        [items]="dumpsters"
                                        valueExpr="id"
                                        displayExpr="size"
                                        (onValueChanged)="dumpsterChanged($event)"
                                    ></dx-select-box>
                                </div>
                                <dxi-form-validation-rule type="required" message="Required"> </dxi-form-validation-rule>
                                <dxi-form-validation-rule type="range" [min]="1" message="Required"> </dxi-form-validation-rule>
                            </dxi-form-item>
                            <dxi-form-item
                                dataField="price"
                                [editorOptions]="{ format: { type: 'currency', precision: 2 }, step: 0 }"
                            ></dxi-form-item>
                            <dxi-form-item
                                dataField="preferredTime"
                                editorType="dxDateBox"
                                [editorOptions]="{ type: 'time' }"
                            ></dxi-form-item>
                            <dxi-form-item
                                dataField="preferredWindow"
                                [label]="{ text: 'Preferred Window' }"
                                [editorType]="'dxSelectBox'"
                                [editorOptions]="{ dataSource: preferredWindowOptions }"
                            >
                            </dxi-form-item>
                            <dxi-form-item
                                dataField="billDaily"
                                cssClass="show-labels"
                                [label]="{ text: 'Bill Daily', location: 'left' }"
                                [editorType]="'dxCheckBox'"
                            >
                            </dxi-form-item>
                            @if (rental.billDaily) {
                                <dxi-form-item
                                    dataField="dailyRate"
                                    [editorOptions]="{ format: { type: 'currency', precision: 2 }, step: 0 }"
                                ></dxi-form-item>
                            }
                            @if (!rental.billDaily) {
                                <dxi-form-item itemType="empty"></dxi-form-item>
                            }
                            <dxi-form-item itemType="empty"></dxi-form-item>
                            <dxi-form-item itemType="empty"></dxi-form-item>
                            <dxi-form-item
                                dataField="driverInstructions"
                                editorType="dxTextArea"
                                [colSpan]="4"
                                [editorOptions]="{ height: 100 }"
                            ></dxi-form-item>
                            <dxi-form-item
                                dataField="notes"
                                editorType="dxTextArea"
                                [colSpan]="4"
                                [editorOptions]="{ height: 100 }"
                            ></dxi-form-item>
                            <dxi-form-item
                                dataField="invoiceNotes"
                                editorType="dxTextArea"
                                [colSpan]="4"
                                [editorOptions]="{ height: 100 }"
                            ></dxi-form-item>
                        </dxi-form-item>
                    </dx-form>
                </div>
                @if (jobs) {
                    <div class="d-flex flex-fill flex-column">
                        <dx-data-grid
                            #jobGrid
                            keyExpr="id"
                            class="flex-fill d-flex flex-column horizontal-scrolling"
                            height="700px"
                            [dataSource]="jobs"
                            [showBorders]="true"
                            [wordWrapEnabled]="false"
                            (onToolbarPreparing)="onToolbarPreparing($event)"
                            (onCellPrepared)="onCellPrepared($event)"
                        >
                            <dxi-data-grid-column
                                dataField="id"
                                caption="Job #"
                                width="70"
                                [sortIndex]="1"
                                [sortOrder]="'desc'"
                            ></dxi-data-grid-column>
                            <dxi-data-grid-column dataField="jobType.name" caption="Job Type" width="85"></dxi-data-grid-column>
                            <dxi-data-grid-column dataField="action.name" caption="Action" width="85"></dxi-data-grid-column>
                            <dxi-data-grid-column dataField="driver.displayName" caption="Driver" width="150"></dxi-data-grid-column>
                            <dxi-data-grid-column dataField="dumpster.size" caption="Dumpster" width="75"></dxi-data-grid-column>
                            <dxi-data-grid-column dataField="dumpsterUsed" caption="Dumpster #" width="95"></dxi-data-grid-column>
                            <dxi-data-grid-column dataField="weight" width="75"></dxi-data-grid-column>
                            <dxi-data-grid-column
                                dataField="totalTime"
                                width="75"
                                [format]="{ type: 'fixedPoint', precision: 2 }"
                            ></dxi-data-grid-column>
                            <dxi-data-grid-column
                                dataField="margin"
                                caption="Margin"
                                width="95"
                                [format]="{ type: 'percent', precision: 2 }"
                                cellTemplate="marginTemplate"
                            ></dxi-data-grid-column>
                            <dxi-data-grid-column
                                dataField="invoiceNumber"
                                caption="Invoice #"
                                width="100"
                                cellTemplate="invoiceTemplate"
                            ></dxi-data-grid-column>
                            <dxi-data-grid-column
                                dataField="invoiceTotal"
                                width="75"
                                [format]="{ type: 'currency', precision: 2 }"
                            ></dxi-data-grid-column>
                            <dxi-data-grid-column dataField="startDate" caption="Date" width="100"></dxi-data-grid-column>
                            <dxi-data-grid-column dataField="started" format="shortDateShortTime" width="135"></dxi-data-grid-column>
                            <dxi-data-grid-column dataField="completed" format="shortDateShortTime" width="135"></dxi-data-grid-column>
                            <dxi-data-grid-column dataField="dumpSite.name" caption="Dump Location" width="135"></dxi-data-grid-column>
                            <dxi-data-grid-column dataField="displayAddress" caption="Service Address" width="250"></dxi-data-grid-column>
                            <dxi-data-grid-column
                                dataField="fuelRatePercentage.rate"
                                caption="Fuel Rate Percentage"
                                width="100"
                            ></dxi-data-grid-column>
                            <dxi-data-grid-column dataField="hourExpense" width="75"></dxi-data-grid-column>
                            <dxi-data-grid-column dataField="hourExpenseTotal" width="75"></dxi-data-grid-column>
                            <dxi-data-grid-column dataField="tonExpense" width="75"></dxi-data-grid-column>
                            <dxi-data-grid-column dataField="tonExpenseTotal" width="75"></dxi-data-grid-column>
                            <dxi-data-grid-column
                                dataField="rental.customer.displayName"
                                caption="Customer"
                                width="180"
                            ></dxi-data-grid-column>
                            <dxi-data-grid-column dataField="marginTime" width="75"></dxi-data-grid-column>
                            <dxi-data-grid-column dataField="driverNotes"></dxi-data-grid-column>
                            <div *dxTemplate="let cell of 'invoiceTemplate'">
                                <a [routerLink]="'/invoices/' + cell.data.invoiceId">{{ cell.text }}</a>
                            </div>
                            <div *dxTemplate="let cell of 'marginTemplate'">
                                <a [routerLink]="[]" (click)="openMargin(cell.data.id)">{{ cell.text }}</a>
                            </div>
                            <dxo-data-grid-summary>
                                <dxi-data-grid-total-item
                                    column="margin"
                                    summaryType="avg"
                                    [valueFormat]="{ type: 'percent', precision: 2 }"
                                >
                                </dxi-data-grid-total-item>
                            </dxo-data-grid-summary>
                            <dxo-data-grid-selection mode="multiple"></dxo-data-grid-selection>
                            <dxo-data-grid-sorting mode="multiple"></dxo-data-grid-sorting>
                            <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
                            <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
                            <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
                            <dxo-data-grid-state-storing
                                [enabled]="true"
                                type="localStorage"
                                storageKey="rental-detail-job-overview-grid"
                            ></dxo-data-grid-state-storing>
                            <div *dxTemplate="let data of 'toolbarButtons'">
                                <button
                                    class="btn btn-danger mb-2 me-2"
                                    (click)="deleteJob()"
                                    [disabled]="jobGrid.instance.getSelectedRowsData().length === 0"
                                >
                                    Delete
                                </button>
                                <button
                                    class="btn btn-primary mb-2 me-2"
                                    (click)="editJobTimes(jobGrid.instance.getSelectedRowsData()[0])"
                                    [disabled]="jobGrid.instance.getSelectedRowsData().length !== 1"
                                >
                                    Edit Job Times
                                </button>
                                <!-- <button
                class="btn btn-secondary mb-2 me-2"
                (click)="calculateJobTime()"
                [disabled]="jobGrid.instance.getSelectedRowsData().length === 0"
                >
                Recalculate Job Time
              </button> -->
                                <button
                                    class="btn btn-secondary mb-2"
                                    (click)="calculateJobMargins()"
                                    [disabled]="jobGrid.instance.getSelectedRowsData().length === 0"
                                >
                                    Recalculate Job Margin
                                </button>
                            </div>
                            <div *dxTemplate="let data of 'toolbarText'">
                                <!-- <span class="average-margin">Global Average Margin: {{ averageMargin | percent : '1.2-2' }} <br /> </span> -->
                            </div>
                        </dx-data-grid>
                    </div>
                }
            </div>
        }
    </div>
</div>
